import { render } from "./VatView.vue?vue&type=template&id=41dd7fe2"
import script from "./VatView.vue?vue&type=script&lang=js"
export * from "./VatView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__